import { Injectable } from '@angular/core';
import { Selector } from '@ngxs/store';
import { DmsIntegrationStateSelectors, UploadFileStateRecord } from '@aiwyn/shared';
import { ClientRequestsState } from '../../../state/client-requests.state';
import { ClientRequestDocumentFileDisplay } from '../../../models';

@Injectable({ providedIn: 'root' })
export class ClientRequestPanelSelectors {
  @Selector([ClientRequestsState.getUploadedFileDisplays, DmsIntegrationStateSelectors.getUploadFileJobs])
  static getUploadedFileJobIds(displayFiles: ClientRequestDocumentFileDisplay[], uploadedJobs: UploadFileStateRecord[]): string[] {
    const cloudUploadedFileIds = displayFiles.map((file) => file.id);
    const jobs = uploadedJobs?.filter((file) => cloudUploadedFileIds.includes(file.data?.fileId)) ?? [];
    return jobs.map((job) => job.jobId);
  }
}
